import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import createMutationsSharer from 'vuex-shared-mutations'

Vue.use(Vuex)
const initFilter = () => ({
    sort: '',
    order: '',
    keyword: '',
    per_page: 10,
    page: 1,
});

// Vue.config.devtools = true;

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
            reducer: state => ({
                menu: {
                    show: state.menu.show,
                },
                filters: state.filters,
                redirect_notification: state.redirect_notification,
            }),
        }),
        createMutationsSharer({
            predicate: (mutation, state) => {
                const predicate = [
                    'toggleMenuShow'
                ];

                return predicate.indexOf(mutation.type) >= 0;
            }
        })
    ],

    state: {
        menu: {
            show: true,
            transitioning: false,
        },
        submitting: false,
        customErrors: [],
        validationErrors: {},
        notification: '',
        notification_type: 'success',
        filters: {
            sort: '',
            order: '',
            keyword: '',
            per_page: 10,
            page: 1,
        },
        unique_page_id: '',
        debounceMS: document.documentElement.lang == 'en' ? 500 : 800,
        lang: {},
        notify_option: {
            group: 'system',
            duration: 7000,
            speed: 1000,
            data: {},
            max: 10,
            clean: true,
            closeOnClick: true
        },
    },

    mutations: {
        receiveLang(state, lang) {
            state.lang = __LANG__;
        },
        toggleMenuTransitioning(state) {
            state.menu.transitioning = !state.menu.transitioning;
        },
        toggleMenuShow(state) {
            state.menu.show = !state.menu.show;
        },
        setMenuShow(state, show) {
            state.menu.show = show;
        },
        setError(state, errorMsg) {
            // state.customErrors = [errorMsg];
            Vue.notify({
                group: state.notify_option.group,
                clean: false,
                type: 'error',
                text: errorMsg,
                duration: state.notify_option.duration,
                speed: state.notify_option.speed,
                data: {},
                max: state.notify_option.max,
                closeOnClick: state.notify_option.closeOnClick
            });
        },
        pushError(state, errorMsg) {
            state.customErrors.push(errorMsg);
        },
        clearError(state, errorMsg) {
            state.customErrors = [];
        },
        setFilterSort(state, sort) {
            if(!_.isNil(state.unique_page_id) && !_.isEmpty(state.unique_page_id)){
                Vue.set(state.filters, (state.unique_page_id + '_sort'), sort);
            }
            else{
                state.filters.sort = sort;
            }
        },
        setFilterOrder(state, order) {
            if(!_.isNil(state.unique_page_id) && !_.isEmpty(state.unique_page_id)){
                Vue.set(state.filters, (state.unique_page_id + '_order'), order);
            }
            else{
                state.filters.order = order;
            }
        },
        toggleFilterOrder(state) {
            if(!_.isNil(state.unique_page_id) && !_.isEmpty(state.unique_page_id)){
                Vue.set(state.filters, (state.unique_page_id + '_order'), state.filters[(state.unique_page_id + '_order')] == 'desc' ? 'asc' : 'desc');
            }
            else{
                state.filters.order = state.filters.order == 'desc' ? 'asc' : 'desc';
            }
        },
        setFilterKeyword(state, keyword) {
            if(!_.isNil(state.unique_page_id) && !_.isEmpty(state.unique_page_id)){
                Vue.set(state.filters, (state.unique_page_id + '_keyword'), keyword);
            }
            else{
                state.filters.keyword = keyword;
            }
        },
        setFilterKeywordViaEvent(state, event) {
            if(!_.isNil(state.unique_page_id) && !_.isEmpty(state.unique_page_id)){
                Vue.set(state.filters, (state.unique_page_id + '_keyword'), event.target.value);
            }
            else{
                state.filters.keyword = event.target.value;
            }
        },
        setFilterViaEvent(state, {filter, event}) {
            if (event.target.value) {
                Vue.set(state.filters, filter, $(event.target).val());
            }
        },
        setFilter(state, {_filter, _value}) {
            // if (window._.isEmpty(_value)) {
            //     Vue.delete(state.filters, _filter);
            // } else {
            //     Vue.set(state.filters, _filter, _value);
            // }

            // allow to store with empty value
            Vue.set(state.filters, _filter, _value);
        },
        resetFilters(state) {
            state.filters = initFilter();
        },
        resetTableRelatedFilters(state) {
            state.filters.sort = '';
            state.filters.order = '';
            state.filters.page = 1;
            state.filters.per_page = 10;
        },
        setFilterPage(state, page) {
            if(!_.isNil(state.unique_page_id) && !_.isEmpty(state.unique_page_id)){
                Vue.set(state.filters, (state.unique_page_id + '_page'), page);
            }
            else{
                state.filters.page = page;
            }
        },
        setFilterPerPage(state, perPage) {
            if(!_.isNil(state.unique_page_id) && !_.isEmpty(state.unique_page_id)){
                Vue.set(state.filters, (state.unique_page_id + '_per_page'), perPage);
            }
            else{
                state.filters.per_page = perPage;
            }
        },
        setSubmitting(state, status) {
            state.submitting = status;
        },
        setRedirectNotification(state, msg) {
            state.submitting = true; // disabled all submit button
            state.redirect_notification = msg;
        },
        clearRedirectNotification(state, msg) {
            state.redirect_notification = '';
        },
        setNotification(state, msg) {
            state.notification = msg;

            let notify_type = 'success';
            if (state.notification_type == 'danger')
            {
                notify_type = 'error';
            } else if (state.notification_type == 'warning') {
                notify_type = 'warn';
            }

            Vue.notify({
                group: 'system',
                clean: false,
                type: notify_type,
                width: '100%',
                position: 'top center',
                text: msg,
                duration: state.notify_option.duration,
                speed: state.notify_option.speed,
                data: {},
                max: state.notify_option.max,
                closeOnClick: state.notify_option.closeOnClick
            });
        },
        setNotificationType(state, type) {
            state.notification_type = type;
        },
        clearNotification(state) {
            state.notification = '';
            state.notification_shown = false;
        },
        setValidationError(state, errors) {
            state.validationErrors = errors;
        },
        clearValidationError(state) {
            state.validationErrors = {};
        },
        setVeeValidationError(state, veeErrors) {
            /** convert errorBag to local error format **/
            var errors = [];
            _.each(veeErrors.items, function (item) {
                if(!errors[item.field]) {
                    errors[item.field] = [];
                }
                errors[item.field][0] = item.msg;
            });
            state.validationErrors = errors;
        },
        setUniquePageId(state, pageId){
            state.unique_page_id = pageId;
        }
    },
    getters: {

        query(state) {
            let string_init = true;
            let queryStr = Object.keys(state.filters).reduce(function (str, key, i) {
                let delimiter, val = '';

                key = encodeURIComponent(key);

                if (Array.isArray(state.filters[key])) {
                    if (state.filters[key].length > 0) {
                        val = encodeURIComponent(state.filters[key].join('|-|'));
                    }
                } else {
                    if (state.filters[key] != null && state.filters[key] != '') {
                        val = encodeURIComponent(state.filters[key]);
                    }
                }

                //Check if there is a unique_page_id
                if(!_.isNil(state.unique_page_id) && state.unique_page_id != ''){
                    if(key.startsWith(state.unique_page_id)){
                        key = key.substr(state.unique_page_id.length+1);

                        if (val != '') {
                            delimiter = (string_init) ? '?' : '&';
                            string_init = false;
                            return [str, delimiter, key, '=', val].join('');
                        } else {
                            return str;
                        }
                    }
                    else{
                        return str;
                    }
                }
                else{
                    if (val != '') {
                        delimiter = (string_init) ? '?' : '&';
                        string_init = false;
                        return [str, delimiter, key, '=', val].join('');
                    } else {
                        return str;
                    }
                }
            }, '');

            return queryStr;
        },
        isSubmitting(state) {
            return state.submitting;
        },
        debounceMS(state) {
            return state.debounceMS
        },
        hasError: state => key => {
            if (key == '*') {
                return !_.isEmpty(state.validationErrors);
            }
            return state.validationErrors[key]
        },
        showError: state => key => state.validationErrors[key][0],
        lang: state => state.lang,
    }

});





// WEBPACK FOOTER //
// ./resources/assets/js/store/store.js